import {Button} from 'antd'
import {medal_getMedals_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo} from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose, fromRenderProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {MedalsSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import ListHeader from 'views/AppLocals/Templates/items/ListHeader'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import WorkspaceContext from '../WorkspaceContext'
import MedalFilter from './MedalFilter'
import renderMedal from './renderMedal'
import {useMedalManager} from './userMedalManager'
import {useRouteSearchParam} from "../../../envs/_current/history";
import {BiSolidEdit, BiTrash} from "react-icons/bi";

const WorkspaceMedalsList = ({
                               owner_id,
                               owner_type,
                               Wrapper = 'div',
                               filter_actions = {
                                 sortBy: 'sort-by',
                                 keyword: 'keyword',
                                 active: 'active',
                               },
                             }) => {
  const t = useTranslate()

  const location = useLocation()

  const sortBy = useRouteSearchParam(filter_actions.sortBy)

  const active = useRouteSearchParam(filter_actions.active)

  const {
    refreshKey,
    modal = null,
    handleAction = NullAsDefault,
  } = useMedalManager({
    owner_id,
    owner_type,
  })

  const refresh_deps = useMemo(
    () => [
      owner_id,
      owner_type,
      refreshKey,
      `refreshToken=${_.get(location.state, 'refreshToken')}`,
    ],
    [owner_id, owner_type, refreshKey, location.state]
  )

  const renderContextMenu = useCallback(
    (item) =>
      createContextMenu(
        [
          {
              icon: <BiSolidEdit size={14} className="text-blue-500"/>,
              label: 'edit',
              key: CRUD.UPDATE,
          },
          {
              icon: <BiTrash size={14} className="text-primary-300" />,
              label: 'delete',
              key: CRUD.DELETE,
          },
        ].filter((e) => item),
        (key) => {
          handleAction(key, item)
        }
      ),
    []
  )

  const [pager_widget] = usePaginationHelper({
    onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
      onFilterChange({
        active,
      })
      onSortChange(sortBy)
    },
    pagerInfo: {
      apiInfo: medal_getMedals_Api,
      RenderEntity: React.Fragment,
      renderItem: renderMedal({
        renderContextMenu,
      }),
      query: bindQueryParams([{id: owner_id}, {prop: owner_type}]),
    },
    sortHeader: t('list of certification'),
    SortByWidget: MedalsSortBy,
    AdvancedFilter: MedalFilter,
    query_params: filter_actions,
    dependencies: [owner_id, owner_type],
    withKey: createPagerKey(refresh_deps),
  })

  return (
    <Wrapper className="flex flex-col space-y-3">
      <ListHeader
        title="certification"
        extra={
          <Button
            className="button-rounded-lg no-border"
            type="primary"
            onClick={() => {
              handleAction(CRUD.CREATE)
            }}>
            {t('create')}
          </Button>
        }
      />
      {pager_widget}
      {modal}
      <div className="h-10"/>
    </Wrapper>
  )
}

export default compose(
  fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
    owner_id: getId(organization),
    owner_type: getType(organization),
  })),
  branch(
    ({owner_id, owner_type}) => _.some([owner_id, owner_type], (e) => !e),
    () => () => <ContentNotFound/>
  )
)(WorkspaceMedalsList)
